module.exports = __webpack_public_path__ + "img/varder.e44a17b7.png";